export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_9554_START_GENERIC_OBSERVATION': 'Start Generic Observation',
    '_9555_START_GENERIC_COMMITMENT': 'Start Generic Commitment',
    '_9505_DO_YOU_WANT_TO_CREATE_A_NEW_OBSERVATION_': 'Do you want to create a new observation?',
    '_9556_DO_YOU_WANT_TO_CREATE_A_NEW_COMMITMENT_': 'Do you want to create a new commitment?',
    '_9557_DO_YOU_WANT_TO_OBSERVE_OR_COMMIT_A_NEW_FOCUS_FOR_THIS_METRIC_': 'Do you want to Observe or Commit a New Focus for this Metric?',
    '_9558_THIS_METRIC_DOES_NOT_HAVE_A_GOAL_ON_AN_ACTIVE_COMMITMENT_': 'This metric does not have a goal on an active commitment.',
    '_9559_NEW_OBSERVATION': 'New Observation',
    '_9775_NEW_COMMITMENT': 'New Commitment',
    '_9479_CONFIRMATION': 'Confirmation',
    '_9297_YES': 'Yes',
    '_9298_NO': 'No',
    '_9560_PLEASE_SELECT_AN_OPPORTUNITY_ON_THE_LEFT_': 'Please select an Opportunity on the left.',
    '_714__30_DAY': '30 Day',
    '_202_DAILY': 'Daily',
    '_203_WEEKLY': 'Weekly',
    '_204_MONTHLY': 'Monthly',
    '_721_GOAL': 'Goal',
    '_767___TO_GOAL': '% to Goal',
    '_768___TO_TARGET': '% to Target',
    '_7398_VARIANCE': 'Variance',
    '_989_TREND': 'Trend',
    '_555_DETAIL': 'Detail',
    '_7456_ACTUAL_LINE': 'Actual Line',
    '_7459_OPPORTUNITY_LINE': 'Opportunity Line',
    '_9456_OBSERVATION_EVENT': 'Observation Event',
    '_9457_COMMITMENT_EVENT': 'Commitment Event',
    '_9458_MULTIPLE_COACHING_EVENTS': 'Multiple Coaching Events',
    '_7457_TARGET_LINE': 'Target Line',
    '_7458_GOAL_LINE': 'Goal Line',
    '_9480_SUPERGROUP_AVERAGE': 'Supergroup Average',
    '_9454_ACTIVE_GOAL': 'Active Goal',
    '_9455_HISTORIC_GOALS': 'Historic Goals',
    '_725_ACTUAL': 'Actual',
    '_726_TARGET': 'Target',
    '_7368_OPPORTUNITY_THRESHOLD': 'Opportunity Threshold',
    '_7369_GAP_TO_OPPORTUNITY_LINE': 'Gap to Opportunity Line',
    '_9429_SHOW_SUPERGROUP_AVG': 'Show Supergroup Avg.',
    '_9430_NO_METRIC_PERFORMANCE_DATA': 'No Metric Performance Data.',
    '_9817_DO_YOU_WANT_TO_OBSERVE_OR_COMMIT_A_FOCUS_FOR_THIS_METRIC': 'Do you want to Observe or Commit a focus for this metric?',
    '_9818_THIS_METRIC_HAS_A_PENDING_GOAL_IN_PROGRESS': 'This metric has a pending goal in progress'
};
